"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ConnectedTenantPicker = exports.mapDispatchToProps = exports.mapStateToProps = void 0;

var _reactI18next = require("react-i18next");

var _reactRedux = require("react-redux");

var _models = require("../../Notifications/models");

var _createAction = require("../../redux/createAction");

var _models2 = require("../models");

var _TenantPicker = require("./TenantPicker");

/**
 * Maps the external (i.e. own) props and the state to the properties of the TenantPicker control.
 * @param state The current redux state to map to props
 * @param ownProps The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (ITenantPickerProps) for the TenantPicker control
 */
var mapStateToProps = function mapStateToProps(_state, ownProps) {
  var options = ownProps.options;
  return {
    options: options
  };
};
/**
 * Maps the dispatch actions to the props for the TenantPicker control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (ITenantPickerProps) for the TenantPicker control
 */


exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var changeTenant = (0, _createAction.createAction)(_models2.UserActions.changeTenant, dispatch);
  return {
    onChange: function onChange(option) {
      if (ownProps.onChange !== undefined) {
        ownProps.onChange(option);
      } else {
        changeTenant(option);
      }
    },
    close: (0, _createAction.createAction)(_models.NotificationsActions.dialogCanceled, dispatch)
  };
};
/**
 * A redux connected TenantPicker control.
 * @description Supports translation
 */


exports.mapDispatchToProps = mapDispatchToProps;
var ConnectedTenantPicker = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.translate)('App')(_TenantPicker.TenantPicker));
exports.ConnectedTenantPicker = ConnectedTenantPicker;